import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=70e4990e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=70e4990e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4990e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e4990e')) {
      api.createRecord('70e4990e', component.options)
    } else {
      api.reload('70e4990e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=70e4990e&scoped=true&", function () {
      api.rerender('70e4990e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22Uxsa3IFjmIX/JS/comp/SearchFilterTokens.vue"
export default component.exports